import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { DatoPaginadoModel } from 'src/app/shared/models/dato-paginado.model';
import { BaseServiceService } from 'src/app/shared/services/base-service.service';
import { MunicipiosSinEstudioAutomaticoService } from './municipios-sin-estudio-automatico.service';
import { MunicipioSinEstudioAutomaticoEntry } from 'src/app/shared/entrys/municipio-sin-estudio-automatico.entry';
import { CampoAdicionalCategoriaService } from "../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service";
import { CategoriaEntry } from "src/app/shared/entrys/categoria.entry";
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { MensajesUsuario } from 'src/app/shared/enumeraciones/mensajes-usuario.enum';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';

@Component({
  selector: 'app-municipios-sin-estudio-automatico',
  templateUrl: './municipios-sin-estudio-automatico.component.html',
  styleUrls: ['./municipios-sin-estudio-automatico.component.scss']
})
export class MunicipiosSinEstudioAutomaticoComponent implements OnInit, OnDestroy {

  formEdicion: FormGroup;
  formFiltros: FormGroup;
  isCollapsed = true;

  camarasComercio = [];
  fCamarasComercio = [];

  departamentos = [];
  fDepartamentos = [];

  municipios = [];
  fMunicipios = [];

  tipoSolicitudes = [
    { tipo_solicitud_id: 1, descripcion: 'Inscripcion' },
    { tipo_solicitud_id: 2, descripcion: 'Renovación' }
  ];
  fTipoSolicitudes = [
    { tipo_solicitud_id: 1, descripcion: 'Inscripcion' },
    { tipo_solicitud_id: 2, descripcion: 'Renovación' }
  ];

  encabezadosTabla = [
    'Camara de Comercio',
    'Departamento',
    'Municipio',
    'Categoria',
    'Tipo Solicitud',
    'Acción'
  ];
  dataTable: DatoPaginadoModel;
  paginaActual = 1;
  cantidadPorPagina = 12;


  categoria: Array<CategoriaEntry> = [];
  categoriafil: Array<CategoriaEntry> = [];

  private _subscripcionCamaraComercioValueChanges: Subscription | undefined;
  private _subscripcionDepartamentoValueChanges: Subscription | undefined;
  private _subscripcionFCamaraComercioValueChanges: Subscription | undefined;
  private _subscripcionFDepartamentoValueChanges: Subscription | undefined;

  constructor(
    private _fb: FormBuilder,
    private _baseServices: BaseServiceService,
    private _alertService: AlertsService,
    private _municipiosSinEstudioAutomticoService: MunicipiosSinEstudioAutomaticoService,
    private _modalService: NgbModal,
    private categoriaService: CampoAdicionalCategoriaService,
  ) {
  }

  ngOnInit(): void {
    this.formEdicion = this._fb.group({
      camaraComercioCtrl: ['', []],
      departamentoCtrl: ['', []],
      municipioCtrl: ['', [Validators.required]],
      tipoSolicitudCtrl: ['', [Validators.required]],
      fcategoriaCtrl:['',Validators.required],
    });

    this.formFiltros = this._fb.group({
      fCamaraComercioCtrl: ['', []],
      fDepartamentoCtrl: ['', []],
      fMunicipioCtrl: ['', []],
      fCategoriaCtrl: ['', []],
      fTipoSolicitudCtrl: ['', []],
      fcategoriaCtrl: ['',[]],
    });


    this.onCategoriaSelect();
    this.onCategoriaSelectFiltro();
    this.cargarCatalogos();
    this.observarFormularios();
    this.refrescar();
  }

  ngOnDestroy(): void {
    this._subscripcionCamaraComercioValueChanges?.unsubscribe();
    this._subscripcionDepartamentoValueChanges?.unsubscribe();

    this._subscripcionFCamaraComercioValueChanges?.unsubscribe();
    this._subscripcionFDepartamentoValueChanges?.unsubscribe();
  }

  guardar() {
    if (!this.formEdicion.valid) {
      this.formEdicion.markAllAsTouched();
      return;
    }
    let { municipioCtrl, tipoSolicitudCtrl,fcategoriaCtrl } = this.formEdicion.value;
    let municipioSinEstudioAutomatico: MunicipioSinEstudioAutomaticoEntry = {
      codigo_municipio: municipioCtrl,
      tipo_solicitud_id: tipoSolicitudCtrl,
      categoria_id : fcategoriaCtrl,
    };

    this._municipiosSinEstudioAutomticoService.Crear(municipioSinEstudioAutomatico).pipe(take(1)
    ).subscribe(respuesta => {
      if (respuesta.result) {
        this.limpiarFormEdicion();
        this.refrescar();
        this._alertService.success(MensajesUsuario.GuardadoExitoso,null,null);
      } else if ( respuesta.result === false &&  respuesta.control.code == 409) {
        this._alertService.warn(respuesta.control.message, null,null);
      } else {
        this.mostrarMensajeDeError();
      }
    });
  }

  eliminar(municipioSinEstudioAutomatico: MunicipioSinEstudioAutomaticoEntry) {
    const modalRef = this._modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Está seguro de eliminar el municipio de la configuración de municipios sin estudio automático?`;
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result.then(() => {
      this._municipiosSinEstudioAutomticoService.eliminar(municipioSinEstudioAutomatico).subscribe(resultado => {
        if (resultado.result) {
          const index = this.dataTable.items.findIndex(
            e => e.codigo_municipio == municipioSinEstudioAutomatico.codigo_municipio &&
              e.categoria_id == municipioSinEstudioAutomatico.categoria_id &&
              e.tipo_solicitud_id == municipioSinEstudioAutomatico.tipo_solicitud_id
          )

          this.dataTable.items.splice(index, 1);
        }
      });
    });
  }

  filtrar() {
    this.refrescar();
  }

  limpiarFormEdicion() {
    this.formEdicion.reset();
  }

  limpiarFormFiltros() {
    this.formFiltros.reset();
  }


  onPaginado(value: number) {
    this.paginaActual = value;
    this.filtrar();
  }

  refrescar() {
    const { fCamaraComercioCtrl, fDepartamentoCtrl, fMunicipioCtrl, fTipoSolicitudCtrl,fcategoriaCtrl } = this.formFiltros.value;

    const filtro = {
      codigo_camara: fCamaraComercioCtrl == '' ? null : fCamaraComercioCtrl,
      codigo_departamento: fDepartamentoCtrl == '' ? null : fDepartamentoCtrl,
      codigo_municipio: fMunicipioCtrl == '' ? null : fMunicipioCtrl,
      tipo_solicitud_id: fTipoSolicitudCtrl == '' ? null : fTipoSolicitudCtrl,
      categoria_id : fcategoriaCtrl =='' ? null : fcategoriaCtrl,
    };

    this._municipiosSinEstudioAutomticoService.obtenerListadoMunicipiosSinEstudioAutomatico(filtro, this.paginaActual, this.cantidadPorPagina).subscribe((response => {
      this.dataTable = response.data as DatoPaginadoModel;
    }));
  }

  private mostrarMensajeDeError() {
    this._alertService.warn(
      MensajesUsuario.Errorgeneral,
      null,
      null
    );
  }

  private cargarCatalogos() {
    this._baseServices.getDepartamento().pipe(take(1)).subscribe(response => {
      this.departamentos = response.result ? response.data : [];
      this.fDepartamentos = response.result ? response.data : [];
    });

    this._baseServices.getCamaraComercio().pipe(take(1)).subscribe(response => {
      this.camarasComercio = response.result ? response.data : [];
      this.fCamarasComercio = response.result ? response.data : [];
    });

    this._baseServices.getMunicipio().pipe(take(1)).subscribe(response => {
      this.municipios = response.result ? response.data : [];
      this.fMunicipios = response.result ? response.data : [];
    });
  }

  private observarFormularios() {
    this._subscripcionCamaraComercioValueChanges = this.formEdicion.get('camaraComercioCtrl').valueChanges.pipe(
      switchMap(codigoCamara => {
        return this._baseServices.getDepartamentosPorCamara({ codigo_camara: codigoCamara });
      })
    ).subscribe(respuesta => {
      this.departamentos = respuesta.result ? respuesta.data : [];
      this.formEdicion.patchValue({ departamentoCtrl: '' });
    });
    this._subscripcionDepartamentoValueChanges = this.formEdicion.get('departamentoCtrl').valueChanges.pipe(
      switchMap(codigoDepartamento => {
        return codigoDepartamento
          ? this._baseServices.getMunicipioByIdDpto(codigoDepartamento)
          : this._baseServices.getMunicipio();
      })
    ).subscribe(respuesta => {
      this.municipios = respuesta.result ? respuesta.data : [];
      this.formEdicion.patchValue({ municipioCtrl: '' });
    });

    this._subscripcionFCamaraComercioValueChanges = this.formFiltros.get('fCamaraComercioCtrl').valueChanges.pipe(
      switchMap(codigoCamara => {
        return this._baseServices.getDepartamentosPorCamara({ codigo_camara: codigoCamara });
      })
    ).subscribe(respuesta => {
      this.fDepartamentos = respuesta.result ? respuesta.data : [];
      this.formFiltros.patchValue({ fDepartamentoCtrl: '' });
    });
    this._subscripcionFDepartamentoValueChanges = this.formFiltros.get('fDepartamentoCtrl').valueChanges.pipe(
      switchMap(codigoDepartamento => {
        return codigoDepartamento
          ? this._baseServices.getMunicipioByIdDpto(codigoDepartamento)
          : this._baseServices.getMunicipio();
      })
    ).subscribe(respuesta => {
      this.fMunicipios = respuesta.result ? respuesta.data : [];
      this.formFiltros.patchValue({ fMunicipioCtrl: '' });
    });
  }

  onCategoriaSelect() {
    this.categoriaService.getCategoria().subscribe((resultado) => {
      if (resultado.result) {
        this.categoria = resultado.data;
      }
    });
  }

  onCategoriaSelectFiltro() {
    this.categoriaService.getCategoria().subscribe((resultado) => {
      if (resultado.result) {
        this.categoriafil = resultado.data;
      }
    });
  }

}
